import { productSerializer } from "../product/serializer"
import { Serializer } from "../serializer"
import { CampaignType, DiscountCampaign } from "./Campaign"


export class DiscountCampaignTypeSerializer implements Serializer {
    fromJson(json: any) {
        const item = new CampaignType()
        item.name = json.name
        item.type = json.type
        item.id = json.uid
        item.value = json.percentage
        return item
    }
    toJson(item: DiscountCampaign) {
        return {
        }
    }
}
export class DiscountCampaignSerializer implements Serializer {
    fromJson(json: any) {
        const item = new DiscountCampaign()
        if (json.campaign) {
            item.campaign = discountCampaignTypeSerializer.fromJson(json.campaign)
        }
        item.discount = json.discount
        item.id = json.id
        item.oldPrice = json.old_price
        item.price = json.price
        item.priceToPay = json.price_to_pay
        item.product = productSerializer.fromJson(json.product)
        item.quantity = json.quantity
        item.sku = json.sku
        return item
    }
    toJson(item: DiscountCampaign) {
        return {
        }
    }
}


export const discountCampaignSerializer = new DiscountCampaignSerializer()
export const discountCampaignTypeSerializer = new DiscountCampaignTypeSerializer()